<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     :style="'background-image: url('+urlGenerator(configData.company_banner)+')'">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100"
                          ref="form" data-url="/admin/users/login" action="store">

                        <div class="text-center mb-4">
                            <img :src="urlGenerator(configData.company_logo)" alt=""
                                 class="img-fluid logo">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <h6 class="text-center mb-0">{{ $t('hi_there') }}</h6>
                                <label class="text-center d-block">{{ $t('log_in_to_your_dashboard') }}</label>
                            </div>
                        </div>
                        <div class="form-row" v-if="marketPlaceVersion">
                            <div class="form-group col-12">
                                <label>{{ $t("log_in_as") }}</label>
                                <app-input
                                    type="select"
                                    id="input-select"
                                    :placeholder="$t('select_a_role')"
                                    v-model="userRole"
                                    @change="setUserInfo"
                                    :list="userTypeList"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_email">{{ $t('email') }}</label>
                                <app-input type="email"
                                           v-model="login.email"
                                           :placeholder="$t('enter_your_email')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           :placeholder="$t('enter_your_password')"
                                           :show-password="true"
                                           :required="true"/>
                            </div>
                        </div>
<!--                        <div class="form-row" v-if="recaptchaEnable == 1">-->
<!--                            <div class="form-group col-12 px-0">-->
<!--                                <re-captcha :site-key="siteKey"></re-captcha>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <app-load-more :preloader="preloader"
                                               :label="$t('login')"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        <div
                            class="form-row form-row flex-column flex-md-row justify-content-center justify-content-md-between justify-content-lg-between">
                            <a :href="urlGenerator('users/password-reset')"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="lock" class="pr-2"/> {{ $t('forgot_password') }}
                            </a>
                        </div>
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') + configData.company_name }}
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- chose modal -->
            <app-modal v-if="chooseModal" :modal-id="modalId" modal-size="fullscreen" @close-moadal="closeChooseModal" :modal-backdrop="false" modal-alignment="center">
                <template slot="body">
                    <div class="d-flex justify-content-center align-items-center h-100 w-100 gap-x-2">
                        <a class="btn btn-primary p-4 d-flex align-items-center gap-x-1" :href="urlGenerator('/')"><app-icon name="rss" :size="16" />{{ $t('feed')}}</a>
                        <a class="btn btn-primary p-4 d-flex align-items-center gap-x-1" :href="urlGenerator('/admin/dashboard')"><app-icon name="pie-chart" :size="16" />{{ $t('dashboard') }}</a>
                    </div>
                </template>
            </app-modal>

        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {urlGenerator} from "../../../helpers/AxiosHelper";
    import {AuthMixin} from "./Mixins/AuthMixin";

    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {},
        props: {
            siteKey: String,
            recaptchaEnable: {},
            marketPlaceVersion: {
                default: false,
            },
        },
        data() {
            return {
                urlGenerator,
                login: {email: '', password: ''},
                chooseModal: false,
                modalId: 'modalId',
                userRole: 0,
                userTypeList: [
                    {
                        id: 0,
                        value: "Select a role",
                        email: null,
                        password: null,
                    },
                    {
                        id: 1,
                        value: "Admin",
                        email: "admin@demo.com",
                        password: 123456,
                    },
                    {
                        id: 2,
                        value: "User",
                        email: "user@demo.com",
                        password: 123456,
                    },
                ],
            };
        },
        methods: {
            setUserInfo() {
                this.userTypeList.map((user) => {
                    if (user.id == this.userRole) {
                        this.login.email = user.email;
                        this.login.password = user.password;
                    }
                });
            },
            submit() {
                this.save(this.login);
            },
            afterSuccess(res) {
                this.openModal()
                // window.location = res.data;
            },
            openModal(){
                this.chooseModal = true
                $('#' + this.modalId).modal('show');
            },
            closeChooseModal(){
                $('#' + this.modalId).modal('hide');
                this.chooseModal = false
            }
        },
        created() {

        }
    }
</script>
